import PropTypes from 'prop-types';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { useOrderContext } from '../../../../../providers/OrderProvider';
import { formatPaymentScheduleHeading } from '../../../../../utils/order/orderPaymentEntry.mjs';
import OrderPaymentScheduleNode from '../../../../order/OrderPaymentScheduleNode';

const OrderPaymentScheduleDetail = ({ modelName, pendingStepFocus, isLast }) => {
	const { order } = useOrderContext();
	const paymentStatusHeading = formatPaymentScheduleHeading(order?.paymentMethod, order?.prePaymentOption);

	return (
		<EventModalMediaContent icon='file-invoice-dollar' heading={paymentStatusHeading}>
			<OrderPaymentScheduleNode modelName={modelName} pendingStepFocus={pendingStepFocus} isLast={isLast} />
		</EventModalMediaContent>
	);
};

OrderPaymentScheduleDetail.propTypes = {
	modelName: PropTypes.string,
	pendingStepFocus: PropTypes.oneOf(['prePayment']),
	isLast: PropTypes.bool,
};

export default OrderPaymentScheduleDetail;
